module.exports = __webpack_public_path__ + "img/备案图标.d0289dc0.png";